import server from "./server";

export const getAllPermissionsApi = async () => {
  const response = await server().get("/permissions");
  return response.data;
};
